// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { CoreState, getLoggedInState, TriggerLoginAction } from '@app/core/state';
import { SPAAuthService } from './spa-auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private store: Store<CoreState>, private auth: SPAAuthService) {}

  readonly isLoggedIn$ = this.store.pipe(select(getLoggedInState));

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.auth.isAuthenticated$.pipe(
      tap(loggedIn => {
        if (!loggedIn) {
          this.auth.login(state.url);
        }
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/auth-guard.service.ts